import { t, useLanguage } from "@/i18n/LanguageContext";
import { useSite } from "@/context/SiteContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const HomeWorkGallery = () => {
  useLanguage();
  const { content } = useSite();
  return <section className="bg-[#F8FAFC] py-16 lg:py-20" data-testid="gallery-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal><Eyebrow>{t("Dal cantiere")}</Eyebrow></Reveal>
      <Reveal delay={0.1}><h2 data-testid="home-gallery-title" className="mt-3 font-display text-3xl font-bold text-brand-navydeep sm:text-4xl">{t("Il lavoro, dal vero")}</h2></Reveal>
      <div data-testid="home-work-gallery-grid" className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {(content.gallery || []).map((g, i) =>
          <Reveal key={g.id || i} delay={Math.min(i * 0.06, 0.24)} className={`min-w-0 ${i % 2 ? "lg:mt-10" : ""}`}>
            <figure data-testid={`gallery-item-${i}`} className="group relative aspect-[3/4] overflow-hidden rounded-lg bg-slate-100">
              <img data-testid={`gallery-image-${i}`} src={g.image} alt={t(g.alt || g.label)} loading="lazy" decoding="async" className="img-spotlight h-full w-full object-cover object-center" />
              <figcaption data-testid={`gallery-caption-${i}`} className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-navydeep/95 via-brand-navydeep/95 via-80% to-transparent p-3 pt-10 text-white">
                <span data-testid={`gallery-label-${i}`} className="block font-mono text-[10px] uppercase leading-relaxed [overflow-wrap:anywhere]">{t(g.label)}</span>
                {g.description && <p data-testid={`gallery-description-${i}`} className="mt-2 text-xs leading-relaxed [overflow-wrap:anywhere]">{t(g.description)}</p>}
              </figcaption>
            </figure>
          </Reveal>
        )}
      </div>
    </div>
  </section>;
};